<template>
    <div>
        <crm-content id="patient-details">
            <template slot="actionLeft">
                <vx-back-button />
                <h4>Patient Details</h4>
            </template>
            <div class="flex flex-wrap">
                <vx-card class="mb-8">
                    <div class="flex w-full flex-nowrap">
                        <h1 class="mb-2 mr-4">
                            {{ patient ? `${patient.firstName} ${patient.lastName}` : 'Unknown' }}
                        </h1>
                        <div class="mb-2 w-1/2">
                            <vx-basic-icon
                                v-if="patient.genderId == 1"
                                class="icon-avatar"
                                rounded
                                icon="UserIcon"
                                :size="9"
                                :color="'lightblue'"
                            ></vx-basic-icon>
                            <vx-basic-icon
                                v-if="patient.genderId == 2"
                                class="icon-avatar"
                                rounded
                                icon="UserIcon"
                                :size="9"
                                :color="'pink'"
                            ></vx-basic-icon>
                            <vx-basic-icon
                                v-if="patient.genderId == 3"
                                class="icon-avatar"
                                rounded
                                icon="UserIcon"
                                :size="9"
                                :color="'lightgreen'"
                            ></vx-basic-icon>
                        </div>
                    </div>
                    <div class="flex w-full flex-nowrap items-center mb-2">
                        Medicare:&nbsp;
                        <vx-chip class="medicareChip">{{
                            patient.medicareNumber ? '#' + patient.medicareNumber : 'none'
                        }}</vx-chip>
                    </div>
                    <div class="flex w-full flex-nowrap">
                        <div class="w-1/2 mb-2 mr-4 flex-col">
                            Date of Birth
                            <div style="color: #94999b">
                                {{ dateOfBirth }}
                            </div>
                        </div>
                        <div class="w-1/2 mb-2 flex-col">
                            Indigenous
                            <div style="color: #94999b">
                                {{ indigenous }}
                            </div>
                        </div>
                    </div>
                    <div class="flex w-full flex-nowrap">
                        <div class="w-1/2 mb-2 mr-4 flex-col">
                            Deceased
                            <div style="color: #94999b">
                                {{ patient.isDeceased ? 'Yes' : 'No' }}
                            </div>
                        </div>
                        <div v-if="patient.isDeceased" class="w-1/2 mb-2 flex-col">
                            Date of Death
                            <div style="color: #94999b">
                                {{ dateOfDeath }}
                            </div>
                        </div>
                    </div>
                    <div class="flex w-full flex-nowrap">
                        <div class="w-1/2 mr-2 flex-col">
                            Has Pension Card
                            <div style="color: #94999b">
                                {{ patient.hasPensionCard ? 'Yes' : 'No' }}
                            </div>
                        </div>
                        <div v-if="patient.hasPensionCard" class="w-1/2 flex-col">
                            Pension Card Number
                            <div style="color: #94999b">
                                {{ patient.pensionCardNumber }}
                            </div>
                        </div>
                    </div>
                    <vs-divider />
                    <h4 class="mb-2">Contact Information</h4>
                    <div class="flex">
                        <div class="flex w-full flex-nowrap flex-col">
                            <vx-address
                                class="w-1/2 mb-2 mr-4"
                                :value="patient.address"
                            ></vx-address>
                            <vx-email
                                class="w-1/2 mb-2 mr-4"
                                label="Email Address"
                                :value="patient.emailAddress"
                            ></vx-email>
                        </div>
                        <div class="flex w-full flex-nowrap flex-col">
                            <vx-phone
                                class="w-1/2 mb-2"
                                :label="'Home Phone'"
                                :value="patient.homePhone"
                            ></vx-phone>
                            <vx-phone
                                class="w-1/2 mb-2"
                                :label="'Work Phone'"
                                :value="patient.workPhone"
                            ></vx-phone>
                            <vx-phone
                                class="w-1/2 mb-2"
                                :label="'Mobile Phone'"
                                :value="patient.mobilePhone"
                            ></vx-phone>
                        </div>
                    </div>
                    <vs-divider />
                    <h4 class="mb-2">Medical Information</h4>
                    <div class="flex w-full flex-nowrap mb-2">
                        <vx-chip
                            v-for="(disease, index) in patient.diseases"
                            :key="index"
                            color="secondary"
                            >{{ disease.description }}
                            {{ disease.id == 7 ? `: ${patient.otherDetails}` : '' }}</vx-chip
                        >
                    </div>
                    <div class="flex w-full flex-nowrap">
                        <div class="w-1/2 mb-2 mr-4 flex-col">
                            Date Approval Granted
                            <div style="color: #94999b">
                                {{ approvalGrantedDate }}
                            </div>
                        </div>
                    </div>
                    <text-viewing
                        label="Additional Notes"
                        name="notes"
                        icon-pack="feather"
                        icon="icon-file-text"
                        class="w-full text-area-height"
                        v-model="patient.additionalNotes"
                        remove-validation-padding
                        disabled
                    />
                    <template slot="footer">
                        <vx-action-icon
                            is-button
                            icon="Edit1Icon"
                            color="warning"
                            @click="showEditor = true"
                        />
                    </template>
                </vx-card>

                <patient-creator
                    v-if="showEditor"
                    v-model="patient"
                    :active.sync="showEditor"
                    @close="showEditor = false"
                />
            </div>
        </crm-content>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CrmContent from '../../crm/components/CrmContent.vue'
// import LeadConversionForm from '../../crm/apps/leads/LeadConversionForm.vue'
import CustomTimeline from '../../crm/components/Timeline/CustomTimeline.vue'
// import AccountDisplay from '@/components/project/Accounts/AccountDisplay'
// import ContactDisplay from '@/components/project/Contacts/ContactDisplay'
// import BdmSuggest from '@/components/project/Suggestions/BdmSuggest'
// import LeadSourceSuggest from '@/components/project/Suggestions/LeadSourceSuggest'
// import MarkLostForm from '../../crm/apps/leads/MarkLostForm.vue'
// import ContactAccount from '@/components/project/Contacts/ContactAccount.vue'
// import LeadTimeline from '../../crm/apps/leads/Timelines/LeadTimeline.vue'
import TextViewing from '../TextViewing.vue'
import PatientCreator from './PatientCreator.vue'

export default {
    name: 'patient-details',
    components: {
        CrmContent,
        // LeadConversionForm,
        CustomTimeline,
        // LeadSourceSuggest,
        // AccountDisplay,
        // BdmSuggest,
        // ContactDisplay,
        // MarkLostForm,
        // ContactAccount,
        // LeadTimeline,
        TextViewing,
        PatientCreator
    },
    props: {
        patientId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            patient: {},
            // isMarkLostOpen: false,
            // isConvertOpen: false,
            preservedPatient: null,
            preservedAddress: null,
            showEditor: false
        }
    },
    watch: {
        patientId: {
            handler: async function (id) {
                if (id) {
                    await this.getDetails()
                }
            },
            immediate: true
        }
    },
    computed: {
        ...mapGetters({
            indigenousOptions: 'maarima/indigenousOptions',
            getIndigenousById: 'maarima/getIndigenousById'
        }),
        dateOfBirth() {
            let dob = this.patient.dateOfBirth
            if (dob) {
                let dobDate = new Date(dob)
                dob =
                    dobDate.getDayOfMonth() +
                    ' ' +
                    dobDate.getMonthName() +
                    ' ' +
                    dobDate.getFullYear()
            }
            return dob
        },
        dateOfDeath() {
            let dod = this.patient.dateOfDeath
            if (dod) {
                let dodDate = new Date(dod)
                dod =
                    dodDate.getDayOfMonth() +
                    ' ' +
                    dodDate.getMonthName() +
                    ' ' +
                    dodDate.getFullYear()
            }
            return dod
        },
        approvalGrantedDate() {
            let agd = this.patient.approvalGrantedDate
            if (agd) {
                let agdDate = new Date(agd)
                agd =
                    agdDate.getDayOfMonth() +
                    ' ' +
                    agdDate.getMonthName() +
                    ' ' +
                    agdDate.getFullYear()
            }
            return agd
        },
        indigenous() {
            if (this.patient.indigenousId) {
                return this.getIndigenousById(this.patient.indigenousId).description
            }
            return this.patient.indigenousId
        }
    },
    methods: {
        revertChanges() {
            this.patient = this.deepCopy(this.preservedPatient)
            this.validate()
        },
        setAddress(address) {
            this.preservedAddress = this.deepCopy(address)
        },
        setPatient(patient) {
            this.patient = patient
            this.preservedPatient = this.deepCopy(patient)
        },
        async save() {
            if (!(await this.validate())) {
                return
            }

            this.loading = true
            try {
                var request = {
                    ...this.patient,
                    contactId: this.patient.contact.id,
                    sourceId: this.patient.source.id
                }

                var patient = await this.$api.patient.update(request)
                this.setPatient(patient)
                this.notifySuccess('Patient Updated', 'Successfully updated patient details.', 3000)
            } catch (error) {
                this.notifyServerError(error)
            } finally {
                this.loading = false
            }
        },
        async getDetails() {
            if (this.patientId) {
                this.loading = true
                try {
                    var patient = await this.$api.patient.fetchById(this.patientId)
                    this.setPatient(patient)
                    this.setAddress(patient.address)
                } catch (err) {
                    this.notifyServerError(err)
                    console.error(err)
                } finally {
                    this.loading = false
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';

p {
    display: flex;
}
p label {
    min-width: 150px;
}

.icon-avatar {
    left: auto;
    right: 0;
    .filler {
        right: -40rem;
    }
}

.link-account {
    height: 150px;
    display: flex;
    border-radius: 10px;
    align-items: center;
    justify-content: center;
    background-color: $content-dark-bg;
    cursor: pointer;
    transition: all 0.2s ease;

    .feather-icon {
        display: none;
        transition: all 0.3s ease;
    }
}

.link-account:hover {
    background-color: rgba(var(--vs-primary), 0.2);
    .feather-icon {
        display: inline;
    }
}
.medicareChip {
    background-color: rgb(0, 123, 69) !important;
    color: rgb(254, 197, 2) !important;
}

.text-area-height {
    min-height: 20rem;

    ::v-deep .vs-con-textarea {
        min-height: 20rem;
    }

    ::v-deep .vs-textarea-primary {
        min-height: 20rem;
    }

    ::v-deep .vx-textarea {
        min-height: 20rem;
    }

    ::v-deep .vx-textarea--input {
        min-height: 20rem;
    }
}
</style>
